module.exports = __webpack_public_path__ + "img/use-guide.6f2731eb.svg";